// extracted by mini-css-extract-plugin
export var labelWrapper = "_dj-0";